import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { Store } from '@ngxs/store';
import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from 'src/app/services/shared.service';
import { JobService } from 'src/app/services/job.service';
import { ActionLogService } from 'src/app/services/actionlog.service';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Utility, Guid } from 'src/app/core/common';
import { PushService } from 'src/app/services/push.service';
import { NgxSmartModalComponent } from 'ngx-smart-modal';

@Component({
  selector: 'app-manage-user',
  templateUrl: './manage-user.component.html',
  styleUrls: ['./manage-user.component.scss']
})
export class ManageUserComponent implements OnInit {
  Utility = Utility;

  constructor(private route: ActivatedRoute, private userService: UserService, private store: Store, private spinner: SpinnerService,
    private authService: AuthService, private sharedService: SharedService, private jobService: JobService, private pushService: PushService,
    private actionLogService: ActionLogService) {
    this.route.queryParams
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(params => {
        if (params.q)
          this.keyword = params.q;
      });

  }
  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  Guid = Guid;

  users: any[];
  current: any;
  total: number;
  keyword: string;
  sort?: number = null;
  isPromoted: any;
  promotedSeeker = false;
  seekerPromoteIsProcessed?: boolean;
  limit = 30;
  packages: any[];
  roles: { [key: string]: boolean } = {};


  tabs: any = {};

  async ngOnInit() {
    if (!this.sharedService.isBrowser)
      return;
    await this.load();
    this.packages = await this.jobService.packages();
  }

  newuser() {
    this.users.splice(0, 0, {});
  }

  async load(page: { from: number, limit: number } = { from: 0, limit: this.limit }) {
    this.spinner.show('search');
    this.current = this.store.selectSnapshot(state => state.auth.user);
    const criteria = {
      Keyword: this.keyword,
      Employer: this.roles['Employer']
        ? { IsPromoted: this.isPromoted }
        : undefined,
      // Roles: Object.getOwnPropertyNames(this.roles).filter(_ => this.roles[_]),
      Agent: this.roles['Agent'] ? {} : undefined,
      Karpasha: this.roles['Karpasha'] ? {} : undefined,
      Operator: this.roles['Operator'] ? {} : undefined,
      Seeker: this.roles['Seeker']
        ? {
          Promoted: this.promotedSeeker ? true : undefined,
          PromoteIsProcessed: this.seekerPromoteIsProcessed
        }
        : undefined,
      Sort: this.sort
    };
    const result = await this.userService.adminGetList(criteria, page.from, page.limit);
    this.users = result.users;
    this.total = result.total;
    this.spinner.hide('search');
  }

  setKey(item: any, key: string, event: Event, field: string) {
    const set = (<HTMLInputElement>event.target).checked;
    if (!item[field]) { item[field] = []; }
    const array = item[field];
    const i = array.indexOf(key);
    if (i >= 0 && !set) { array.splice(i, 1); }
    if (i < 0 && set) { array.push(key); }
  }
  hasKey(array: string[], key: string) {
    return array && array.indexOf(key) >= 0;
  }

  addTag(term) { return term; }

  async save(user: any) {
    const id = user.Id;
    this.spinner.show('action-' + id);
    delete user.AccessRights;
    delete user.Roles;
    Object.assign(user, await this.userService.adminSave(user));
    this.spinner.hide('action-' + id);
  }

  async addCredit(user: any) {
    this.spinner.show('action-' + user.Id);
    user.Credit = await this.userService.addCredit(user.Id, user._credit);
    delete user._credit;
    this.spinner.hide('action-' + user.Id);
  }

  async addResumeCredit(user: any) {
    this.spinner.show('action-' + user.Id);
    user.ResumeCredit = await this.userService.addResumeCredit(user.Id, user._resumeCredit);
    delete user._resumeCredit;
    this.spinner.hide('action-' + user.Id);
  }
  async addNotCompletedResumeCredit(user: any) {
    this.spinner.show('action-' + user.Id);
    user.NotCompletedResumeCredit = await this.userService.addNotCompletedResumeCredit(user.Id, user._NotCompletedResumeCredit);
    delete user._NotCompletedResumeCredit;
    this.spinner.hide('action-' + user.Id);
  }

  async generateCode(user: any) {
    this.spinner.show('action-' + user.Id);
    user._code = await this.authService.generateCode(user.Username);
    this.spinner.hide('action-' + user.Id);
  }
  tab(id: string, t: string) {
    if (this.tabs[id] == t) {
      this.tabs = {};
    } else {
      this.tabs = {};
      this.tabs[id] = t;
    }
  }
  async loadMessages(user: any) {
    user._messages = await this.userService.getUserMessages(user.Id);
  }
  async loadPushTokens(user: any) {
    user._pushTokens = await this.userService.getPushTokens(user.Id);
  }

  pushString = `{
    "Title": "test title", "Text": "", "Icon": "https://karpishe.com/assets/icons/icon.png", 
    "Image": "https://karpishe.com/assets/images/KarpisheLogo.svg", "Link": "/job", "Channel": 0, "Type": -1, "SubType": "admin"
  }`;

  async sendPush(user: any, tokenId?: string) {
    var pushObject = JSON.parse(this.pushString);
    pushObject.UserId = user.Id;
    pushObject.Text = pushObject.Text || (new Date()).toString();
    if (tokenId)
      await this.pushService.testPush(pushObject, tokenId);
    else
      await this.pushService.adminSend(pushObject);
    await this.loadPushTokens(user);
  }
  async loadActions(user: any) {
    user._actions = (await this.actionLogService.search({
      UserIds: [user.Id]
    })).list;
  }
  async tagJobTitle(user: any) {
    let res = await this.userService.adminTagdJobTitles(user.Id);
    user.Seeker._metaJobTitleTags = res.Seeker._metaJobTitleTags;
  }
  async getSuggestions(user: any) {
    let res = await this.userService.suggestByUser(user.Id);
    user.Seeker._suggestions = res;
  }

  stopVanguardData: any;
  calculateStopVanguard(user: any) {
    var lastLog = user.Seeker?.PromoteLogs?.at(-1) || {};
    const pricePerDay = Math.floor(lastLog.PaidPrice / lastLog.Days);
    this.stopVanguardData = {
      userId: user.Id,
      days: lastLog.Days,
      paid: lastLog.PaidPrice,
      pricePerDay,
      remainingDays: user.Seeker.PromoteUntilDays,
      remaining: pricePerDay * user.Seeker.PromoteUntilDays
    };
  }

  @ViewChild('stopVanguardModal') stopVanguardModal: NgxSmartModalComponent;
  async vanguardClearance(userId: string, refund: number) {
    this.spinner.show('stop-vanguard');
    await this.userService.clearance(userId, refund);
    this.spinner.hide('stop-vanguard');
    this.stopVanguardModal.close();
  }

  selectedUser?: any;
  @ViewChild('changeUsernameModal') changeUsernameModal: NgxSmartModalComponent;
  async changeUsername(newUsername: string, skipMobileCheck = false) {
    this.spinner.show('change-username');
    var user = await this.userService.changeUsername(this.selectedUser.Id, newUsername, skipMobileCheck);
    this.selectedUser.Username = user.Username;
    this.spinner.hide('change-username');
    this.changeUsernameModal.close();
  }
  async changePassword(password: string) {
    this.spinner.show('change-username');
    var user = await this.userService.changePassword(this.selectedUser.Id, password);
    this.spinner.hide('change-username');
    this.changeUsernameModal.close();
  }

  async stopKarpasha(userId: string) {
    await this.userService.stopKarpasha(userId);
  }

  async transmit(user: any, to: 'vanguard' | 'karpasha', from?: 'vanguard' | 'karpasha' | 'employer') {
    user = await this.userService.transmit(user.Id, to, from);
  }

  // beautify(text: string) {
  //   try { return JSON.stringify(JSON.parse(text), undefined, 4); }
  //   catch{ return text; }
  // }
}
